import {CommonModule} from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { UntilDestroy } from '@ngneat/until-destroy';
import {TranslateModule} from "@ngx-translate/core";
import { of } from 'rxjs';
import { delay, take } from 'rxjs/operators';
import {TooltipWidthDisabledDirective} from "@atlas-workspace/shared/directives";
import {IsEveryPipe} from "@atlas-workspace/shared/pipes";

@UntilDestroy()
@Component({
  selector: 'atl-button-tabs',
  templateUrl: './button-tabs.component.html',
  styleUrls: ['./button-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, NgbTooltipModule, TooltipWidthDisabledDirective, IsEveryPipe]
})
export class ButtonTabsComponent {
  @Input() set tabs(data: any[]) {
    this.tabsData = data;
    this.scrollEvent()
  }
  @Input() nameKey: string = 'name';
  @Input() selectIndex: number = 0;
  @Input() scrollControl = true;
  @Input() showIcon = true;

  @Output() private readonly selectingTab = new EventEmitter<number>();

  @ViewChild('scrollWrap') set scrollWrap(el: ElementRef<HTMLDivElement>) {
    this.scrollEl = el;
    this.initEventHandling();
  }

  private scrollEl!: ElementRef<HTMLDivElement>;
  public tabsData: any[] = [];
  public arrowLeft = false;
  public arrowRight = false;
  public readonly maxCounterNum = 99;
  private readonly debounceTime = 0;
  public readonly tooltipDelay = 500;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  trackBy(index: number, item: any): number {
    return index;
  }

  get allPlans(): boolean {
    return this.tabsData.every(item => item?.sub_unit_floors_attributes?.every((floor: any) => floor?.file));
  }

  public scrollEvent(): void {
    const scrollLeft = Math.ceil(this.scrollEl?.nativeElement?.scrollLeft);
    const scrollWidth = this.scrollEl?.nativeElement?.scrollWidth - this.scrollEl?.nativeElement?.offsetWidth;
    this.arrowLeft = scrollLeft !== 0;
    this.arrowRight =
      scrollLeft + this.scrollEl?.nativeElement?.clientWidth < this.scrollEl?.nativeElement?.scrollWidth &&
      scrollWidth !== 0;
    this.cdr.detectChanges();
  }

  public scrolling(event: MouseEvent, arrow: 'left' | 'right'): void {
    if (event.button === 0) {
      const scrollLeft = this.scrollEl.nativeElement.scrollLeft;
      this.scrollEl.nativeElement.scrollLeft = arrow === 'left' ? scrollLeft - 60 : scrollLeft + 60;
    }
  }

  public selectTab(index: number): void {
    this.selectIndex = index;
    this.selectingTab.emit(this.selectIndex);
  }

  private initEventHandling(): void {
    of([])
      .pipe(take(1), delay(this.debounceTime))
      .subscribe(() => this.scrollEvent());
  }
}
